import type { Theme } from "@mui/material/styles";
import borders from "../base/borders";
import pxToRem from "../functions/pxToRem";

const { borderRadius } = borders;

/** MenuItem overrides scoped to picker digital clock lists (light + dark). */
export function pickerMenuItemOverrides(theme: Theme) {
  const pickerScope =
    ".MuiMultiSectionDigitalClockSection-root &, .MuiDigitalClock-list &";

  return {
    [pickerScope]: {
      minWidth: "unset",
      width: pxToRem(48),
      maxWidth: pxToRem(56),
      padding: pxToRem(8),
      margin: "2px 4px",
      justifyContent: "center",
      borderRadius: borderRadius.sm,
      fontWeight: 500,
      lineHeight: 1.2,
    },
    [`${pickerScope}.Mui-selected`]: {
      backgroundColor: `${theme.palette.primary.main} !important`,
      color: `${theme.palette.primary.contrastText} !important`,
      "&:hover, &:focus": {
        backgroundColor: `${theme.palette.primary.dark} !important`,
        color: `${theme.palette.primary.contrastText} !important`,
      },
    },
    [`${pickerScope}:hover`]: {
      backgroundColor: theme.palette.action.hover,
    },
  };
}

const pickersLayout = {
  styleOverrides: {
    root: {
      "& .MuiMultiSectionDigitalClockSection-root": {
        width: pxToRem(56),
        minWidth: pxToRem(56),
      },
    },
  },
};

const multiSectionDigitalClockSection = {
  styleOverrides: {
    root: {
      width: pxToRem(56),
      minWidth: pxToRem(56),
    },
    item: {
      minWidth: "unset",
      width: pxToRem(48),
      justifyContent: "center",
    },
  },
};

const digitalClock = {
  styleOverrides: {
    item: {
      minWidth: "unset",
    },
  },
};

export { pickersLayout, multiSectionDigitalClockSection, digitalClock };
